import { formatOneGraphData } from '../../navigationMenuParser';
import { locales } from '../../types';
import englishContent from './english';
import koreanContent from './korean';
import spanishContent from './spanish';
import turkishContent from './turkish';
export function getSignedInFooterNavLinks(locale) {
  var signedInFooterNavLinks = {};

  switch (locale) {
    case locales.es:
    case locales['es-419']:
      signedInFooterNavLinks = spanishContent;
      break;

    case locales.ko:
      signedInFooterNavLinks = koreanContent;
      break;

    case locales.tr:
      signedInFooterNavLinks = turkishContent;
      break;

    default:
      signedInFooterNavLinks = englishContent;
  }

  return formatOneGraphData(signedInFooterNavLinks);
}